import { createFileRoute } from '@tanstack/react-router';

import { SupplierForm } from '~/modules/suppliers/form';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

const title = i18n.t(($) => $.form.pageTitle, { ns: 'suppliers' });

export const Route = createFileRoute('/(main)/suppliers/$supplierId/edit/')({
  beforeLoad: createProtectedRoute({
    routePath: '/suppliers/$supplierId/edit/',
    ...routeParams,
  }),
  component: SupplierForm,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const SUPPLIER_EDIT = buildRouteExport({ Route, ...routeParams });
